module.exports = __webpack_public_path__ + "img/appAsset--organization-ax.011caf9a.svg";